import React from "react";
import { useParams } from "react-router";
import { useSearchParams } from "react-router-dom";
import AddListingAdmin from "./AddListingAdmin";

const EditListingAdmin = () => {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const { id: listingId } = params;
  const isDuplicate = !!searchParams.get("duplicate");

  // Access the query parameter
  const isDraft = searchParams.get("isDraft") === "true";
  return (
    <div>
      <AddListingAdmin
        listingId={isDraft ? null : listingId}
        isDuplicate={isDuplicate}
        draftId={isDraft ? listingId : null}
      />
    </div>
  );
};

export default EditListingAdmin;
